import { render, staticRenderFns } from "./ViewTime.vue?vue&type=template&id=80027a0c&scoped=true"
import script from "./ViewTime.vue?vue&type=script&lang=js"
export * from "./ViewTime.vue?vue&type=script&lang=js"
import style0 from "./ViewTime.vue?vue&type=style&index=0&id=80027a0c&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80027a0c",
  null
  
)

export default component.exports